/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Save_FailedInputs */

const vi_shop_category_save_failed = /** @type {(inputs: Shop_Category_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được danh mục.`)
};

/**

* @param {Shop_Category_Save_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_save_failed = /** @type {((inputs?: Shop_Category_Save_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Save_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_save_failed(inputs)
});